$(document).ready(function () {
  $(document).on("click", "#checkout", function (e) {
    e.preventDefault();
    var selectedValue = $('input[name="payment"]:checked').val();
    var creditLimit = parseInt($(this).attr("data-approval-limit"));
    var bimonthlyLimit = creditLimit / 2;
    var paymentPlan;
    $(".properties-holder")
      .eq(0)
      .find("p")
      .each(function () {
        if ($(this).text().indexOf("Payment") > -1) {
          var thisText = $(this).text().trim().replace(/\s+/g, "");
          console.log(thisText);
          paymentPlan = thisText.replace("Paymentplan:", "");
        }
      });
      console.log('my payment plan is ' + paymentPlan);
    // when user clicks the checkout button, if they're not logged in, we take them to account login page
    if ($(this).hasClass("login-class") && paymentPlan !== "Cashprice") {
      window.location.href = "/account/login";
    } else {
      // now we have to check their limit if it's monthly payment plan - just get first item and understand payment plan
      // anytime we attempt to checkout, we must update all the order detail fields to make sure we can properly understand it on the backend
      // first loop through each item and store the quantity and variant ID
      // empty array definition
      var items = [];
      var primary_products = [];
      var product_types = [];
      $("#custom-cart-items tr").each(function () {
        var variant = $(this).data("variant");
        var quantity = $(this).find('.zajax-cart__qty-input').val();
        console.log('my quantity is ' + quantity);
        // Create an object with the variant and quantity
        var item = {
          variant: variant,
          quantity: quantity,
        };
        
        // Push the object into the items array
        items.push(item);
        var product_type = $(this).data('product-type');
        product_types.push(product_type);
        if (!$(this).hasClass("item-hide")) {
          var imgURL = $(this)
            .find(".reg-cart-item-image")
            .find("img")
            .attr("src");
          var URL = $(this)
            .find(".zactual-title-cart")
            .find("a")
            .attr("href");
          var productTitle = $(this).find(".zactual-title-cart").text().trim();
          var price = $(this)
            .find(".cart-item-price")
            .text()
            .trim()
            .replace(/\s+/g, " ");
          price = price.replace(/[^\d.]/g, "");
          // in order to determine actual cash price, we must take into account payment terms (liquid cannot generate cash price while cart transform is active)
          price = price.replace(".", "");
          price = parseInt(price);
          var cashPrice = 0;
          var properties = {};
          var addedPropertyNames = {}; // Object to keep track of added property names

// Parse the details from .ajax-cart__cart-variants
var detailsText = $(this).find(".properties-holder").html();
var properties = {};
var addedPropertyNames = {};

// Create a temporary div element to parse HTML
var tempDiv = document.createElement('div');
tempDiv.innerHTML = detailsText;

// Find all property paragraphs
var propertyParagraphs = tempDiv.querySelectorAll('.property-p');

propertyParagraphs.forEach(function (paragraph) {
  var propertyNameElement = paragraph.querySelector('b');
  var propertyValueElement = paragraph.querySelector('.actual-option');

  if (propertyNameElement && propertyValueElement) {
    var propName = propertyNameElement.innerText.trim();
    var propValue = propertyValueElement.innerText.trim();

    if (!addedPropertyNames[propName]) {
      // Check if the property name has not been added
      properties[propName] = propValue;
      addedPropertyNames[propName] = true; // Mark this property name as added
    }
  }
});

// Output properties for debugging
console.log(properties);



          // Extract additional properties from the properties-holder
          $(this)
            .find(".properties-holder .property-p")
            .each(function () {
              var propertyName = $(this)
                .find("b")
                .text()
                .trim()
                .replace(/:$/, ""); // Removes colon at the end if present
              var propertyValue = $(this)
                .contents()
                .filter(function () {
                  return this.nodeType === 3; // Node type 3 is a text node
                })
                .text()
                .trim()
                .replace(/\s+/g, " "); // Cleans up spaces and newlines
              console.log('my propery name is ' + propertyName + ' and my value is ' + propertyValue);
              if (!addedPropertyNames[propertyName]) {
                // Check if the property name has not been added
                properties[propertyName] = propertyValue;
                addedPropertyNames[propertyName] = true; // Mark this property name as added
              }
              if (propertyName === "_cashPrice") {
                cashPrice = $(this).find(".actual-option").text();
              }
            });

          // Convert properties object to an array of {name, value} objects
          var propertiesArray = Object.keys(properties).map(function (key) {
            return { name: key, value: properties[key] };
          });

          var handle = $(this).data("handle");
          // Add this to primary products with the properties
          var product = {
            productTitle: productTitle,
            rate: price,
            cashPrice: cashPrice,
            imgURL: imgURL,
            URL: URL,
            handle: handle,
            variant: variant,
            quantity: quantity,
            properties: propertiesArray, // All properties, including details parsed into individual properties
          };
          primary_products.push(product);
        }
      });

      // loop through each product and put image in field
      // Initialize variables to hold the concatenated strings
      var imgURLs = [];
      var titles = [];
      var prices = [];
      var urls = [];
      var variantIds = [];
      var quantities = [];
      var allProductsProperties = []; // Array to hold properties of all products

      // Loop through each product
      primary_products.forEach(function (product) {
        imgURLs.push(product.imgURL);
        titles.push(product.productTitle);
        prices.push(product.price);
        urls.push(product.URL);
        variantIds.push(product.variant);
        quantities.push(product.quantity);

        // Initialize an array to hold the properties for this product
        var propertiesList = [];
        // Convert the product's properties array back into a string, separated by "|"
        product.properties.forEach(function (prop) {
          var cleanedValue = prop.value
            .replace(/<span class="actual-option">/g, "")
            .replace(/<\/span>/g, "")
            .trim();
          if (cleanedValue) {
            var propertiesString = prop.name + ": " + cleanedValue;
            propertiesList.push(propertiesString);
          }
        });

        // Join the properties for this product with a pipe and add it to the allProductsProperties array
        allProductsProperties.push(propertiesList.join("|"));
      });

      // Join the image URLs into a comma-separated string and set it as the value of the #product-image input
      $("#product-image").val(imgURLs.join(","));
      $('#product-type').val(product_types.join(","));
      // Do the same for the other attributes
      $("#product-title").val(titles.join(","));
      $("#product-price").val(prices.join(","));
      $("#product-url").val(urls.join(","));
      $("#variant-ids").val(variantIds.join(","));
      $("#quantities").val(quantities.join(","));

      // For properties, join the all products' properties strings with "||" to separate each product's properties
      $("#properties").val(allProductsProperties.join("||"));
      // Now we push all those items to our order details field
      $("#order-details").val(JSON.stringify(items));
      $("#primary-product-details").val(JSON.stringify(primary_products));
      $("#payment-plan-property").val(selectedValue);

      if (
        paymentPlan === "Monthly" ||
        paymentPlan === "Bi-Monthly" ||
        paymentPlan === "Every Two Weeks"
      ) {
        // we need to compare the cart total to their approval limit
        var originalCartTotal = $(".cart-original-total").text();
        var cartTotal = parseInt($('.js-cart-subtotal').text().replace('$','').replace(',','').replace('.',''));
        cartTotal = parseInt(cartTotal);
        if (paymentPlan === "Monthly") {
          if (cartTotal > creditLimit) {
            alert(
              "Unfortunately your monthly approval limit is $" +
                creditLimit +
                " and you have $" +
                cartTotal +
                " in your cart"
            );
          } else {
           $(".ajax-cart__cart-form").trigger('submit');
          }
        } else if (
          paymentPlan === "Bi-Monthly" ||
          paymentPlan === "Every Two Weeks"
        ) {
          if (cartTotal > bimonthlyLimit) {
            alert(
              "Unfortunately your bi-monthly / two week approval limit is $" +
                bimonthlyLimit +
                " and you have $" +
                cartTotal +
                " in your cart"
            );
          } else {
           $(".ajax-cart__cart-form").trigger('submit');
          }
        }
      } else {
        // this means its cash price and they dont need credit limit
        console.log("No credit limit, Cash price");
       $(".ajax-cart__cart-form").trigger('submit');
      }
    }

  });
  let intervalId = setInterval(function () {
    let $boldClone = $(".bold_clone");

    if ($boldClone.length) {
      console.log("found it, trying to hide it "); // If the element is found in the DOM
      $boldClone.hide();
      clearInterval(intervalId); // Optionally, stop the interval when the element is found
    } else {
      // hide custom button
      const customButtons = document.getElementsByClassName("custom-atc");
      if (customButtons && customButtons.length) {
        customButtons[0].style.display = "none";
      }
    }
  }, 500); // Check every 500ms

  ///////////////////////////////////////////
  ////// CHANGE PLAN FROM PRODUCT PAGE //////
  ///////////////////////////////////////////
  async function asyncNewOptionSelected(selectedOption) {
    console.log('SELECTED OPTION: ', selectedOption);
    return new Promise(function (resolve, reject) {
      console.log("Setting new payment term option: ", selectedOption);
      $(".radio-flex span.radio-custom").addClass("radio-disabled");
      // console.log('Radio buttons disabled.');
      $.ajax({
        type: "GET",
        url: "/cart.js",
        dataType: "json",
        success: function (cart) {
          console.log("Received cart data:", cart);
          var cartItems = cart.items;
          let items = [];

          $(cartItems).each(function (i) {
            let properties_empty_array = [];
            var thisItem = $(this)[0];

            // we need to make sure we store the old key of the cart item on the quantity selector and update it after the fact
          //  console.log(thisItem);

            // Log the existing properties of the item:
       //     console.log("Existing properties:", thisItem.properties);
        //    console.log(selectedOption);

            var properties = {};
            $(thisItem.properties).each(function (key, value) {
              if (key !== "Payment plan") {
                // Preserve all other properties except 'Payment plan'
                properties[key] = value;
              }
            });
            properties[0]["Payment plan"] = selectedOption; // Set the new 'Payment plan'
          //  console.log("right after loop", thisItem.properties);
            console.log(selectedOption);

            // Log the new properties object:
          //  console.log("New properties:", properties[0]);

            const itemObj = {
              id: thisItem.variant_id,
              quantity: thisItem.quantity,
              properties: properties[0],
            };
            items.push(itemObj);
          });

          $.ajax({
            type: "POST",
            url: "/cart/clear.js",
            dataType: "json",
            success: function () {
              $.ajax({
                type: "POST",
                url: "/cart/add.js",
                data: { items: items },
                dataType: "json",
                success: function (data) {
                 // console.log("Cart updated with new payment plan.");
                  updateCartSummary(data);
                  $(".property-p").each(function () {
                    if ($(this).text().trim().indexOf("Payment plan") > -1) {
                      $(this).text("Payment plan: " + selectedOption);
                    }
                  });
                  resolve("Cart cleared and reset");
                },
                error: function (jqXHR, textStatus, errorThrown) {
                //  console.log("AJAX call failed.");
                 // console.log("Status: " + textStatus);
                  //console.log("Error: " + errorThrown);
                  //console.log("Response: " + jqXHR.responseText);
                  reject("Clear cart AJAX call failed");
                },
              });
            },
            error: function () {
              const failText = "Failed to clear cart";
              console.log(failText);
              reject(failText);
            },
          });
        },
        error: function () {
          const failureText = "Failed to fetch updated cart information";
          console.log(failureText);
          reject(failureText);
        },
      });
    });
  }

  /////////////////////////////////////////////
  ////// CUSTOM ADD TO CART BUTTON CLICK //////
  /////////////////////////////////////////////
  $(document).on("click", ".custom-atc", function (e) {
    e.preventDefault();
    $("body").append('<div id="overlay" class="overlay"><div class="loader"></div></div>');
    console.log('clicked');
    // first lets get the option selected by user
    var selectedOptionText = $("#payment-plan-selected").text();
    var randomNumber = Math.floor(Math.random() * 100000000) + 1;
    // console.log('my payment plan is ' + selectedOptionText);
    var items = [];
    var addOnsChecked = 0;

    if ($('input[name="properties[_boldVariantPrices]"]').attr('value') != '0,0') {
      addOnsChecked = 1;
    }
    

    function continueAddingToCart() {
      console.log("my add ons are " + addOnsChecked);
      // If adds on checked
      if (addOnsChecked === 0) {
            // Display an overlay and loader
        $('.js-prod-form-submit').trigger('submit');
      } else {
        if ($('input[name="properties[_boldVariantPrices]"]').attr('value') != '0,0') {
// Get the prices and variants as arrays
var pricesStr = $('input[name="properties[_boldVariantPrices]"]').val();
var valueStr = $('input[data-property-name="_boldVariantIds"]').val();

if (pricesStr && valueStr) {
    var prices = pricesStr.split(",");
    var values = valueStr.split(",");
    var _originalAddOns = [];
    // Loop through each price and variant
    $.each(prices, function (i, price) {
        if (price != '0') {
            var addOnVariant = values[i];
            var addOnQuantity = 1;
            const Newentries = new Map();
            Newentries.set("id", addOnVariant);
            Newentries.set("quantity", addOnQuantity);
            Newentries.set("properties", {
                "Payment plan": selectedOptionText,
                _uniqueID: randomNumber,
            });
            const newerobj = Object.fromEntries(Newentries);
            console.log("adding " + newerobj);
            items.push(newerobj);
            _originalAddOns.push(addOnVariant);
        } else {
            console.log("Skipping variant with price 0: " + values[i]);
        }
    });
}
        }
        var jsonObjProps = { "Payment plan": selectedOptionText };
        if (addOnsChecked === 1) {
          if ($(".bold_option_set").length > 0) {
            $(".bold_option_radio").each(function () {
              // lets loop through these checked properties and see what needs to be added
              var radioChecked = $(this).find("input[type=radio]:checked");
              if ($(this).find("input[type=radio]:checked").length > 0) {
                // radio button is checked, so now we must see if it cost money
                var moneyLength = radioChecked
                  .parent()
                  .parent()
                  .find(".bold_option_value_price").length;
                // if this is 0, we know it's just a property of the product
                // get the title and other details
                var title = radioChecked
                  .parent()
                  .parent()
                  .parent()
                  .parent()
                  .parent()
                  .find(".bold_option_title")
                  .text();
                var checkedValue = radioChecked.attr("value");
                //   console.log('adding this ' + title + 'with this checked value ' + checkedValue);
                jsonObjProps[title] = checkedValue; // Adding new property
              }
            });
            jsonObjProps["_uniqueID"] = randomNumber;
          }
          console.log(jsonObjProps);
          // since there are add ons, we must do a custom function to include them in add to cart function
          // now we must take all of those items and add them to cart at once
          var mainVariant = $(".formVariantId").attr("value");
          var quantity = 1;
          jsonObjProps["_mainProduct"] = "yes";
              // Add the _originalAddOns array to jsonObjProps
          jsonObjProps["_originalAddOns"] = _originalAddOns;
          // since this is the main product, we need to calculate cash price so we can send it to backend order form for NCG
          var mainProductPrice = parseInt(
            $("#product-price-product")
              .find(".price__regular")
              .find("dd")
              .find("span")
              .data("money-price")
          );
          // we need to add on any add ons if they're selected
          $(".custom-swatches__form--input.custom-bold-input").each(
            function () {
              if ($(this).prop("checked") === true) {
                // alert('this is checked ' + $(this).val());
                mainProductPrice += parseInt(
                  $(this).parent().find("label").data("cash-price")
                );
              }
            }
          );
          jsonObjProps["_cashPrice"] = mainProductPrice;
          const Newentries = new Map();
          Newentries.set("id", mainVariant);
          Newentries.set("quantity", quantity);
          Newentries.set("properties", jsonObjProps);
          const newerobj = Object.fromEntries(Newentries);
          items.push(newerobj);
         console.log(items); 
        }
         console.log(items + ' and my length is ' + items.length);
        if (items && items.length) {
          $.ajax({
            type: "POST",
            url: "/cart/add.js",
            data: { items: items },
            dataType: "json",
            success: function (cart) {
              //   console.log("Item added to cart successfully");
             window.location.href = "/cart";
              // console.log("Redirected to cart page, success branch 4");
            },
            error: function (jqXHR, textStatus, errorThrown) {
              console.log("AJAX call failed.");
              console.log("Status: " + textStatus);
              console.log("Error: " + errorThrown);
              console.log("Response: " + jqXHR.responseText);
            },
          });
        } else {
          console.log("Cart cleared successfully");
        }
      }
    }

    console.log("Changing time plan to: ", selectedOptionText);
    asyncNewOptionSelected(selectedOptionText)
      .then(() => {
        console.log("Cart cleared successfully");
        continueAddingToCart();
      })
      .catch((error) => {
        console.error("Error from clearing cart: ", error);
        continueAddingToCart();
      });
  });

  $(document).on("click", ".custom-swatches__form--label", function (e) {
    e.preventDefault();
    // we must remove all checks from the radio buttons and check the right one
    $(this)
      .parent()
      .parent()
      .find(".custom-swatches__form--input")
      .each(function () {
        $(this).prop("checked", false);
        $(this).removeAttr("checked");
      });
    // now lets set the right radio button
    $(this).parent().find("input").prop("checked", true);
    $(this).parent().find("input").attr("checked", "checked");
    $(this)
      .parent()
      .parent()
      .parent()
      .find(".swatches__option-value")
      .text($(this).text().trim());
    if (
      $(this).parent().parent().parent().attr("class") ===
      "payment-plan-dropdown"
    ) {
      var currentSelection = $(this).parent().find("input").val();
      // depending on the new value, we need to change the price and make sure it is actually correct
      $("#payment-plan-selected").text($(this).text().trim());
      $('#payment-plan-prop').val(currentSelection);
      // we also need to make sure we set the payment plan so that the Shopify function cart transform is fired in the cart
      // Populate the div with the selected payment plan
      $("#payment-plan").val(currentSelection);
      $("#payment-plan").next("div").text(currentSelection);
      // we need to change the price-follow div to say per month, twice per month etc.
      if (currentSelection === "Monthly") {
        // anytime this changes, not only must we change the text but we also must change all the bold options w/ prices
        $(".payment-follow").text("per month");
      } else if (currentSelection === "Bi-Monthly") {
        $(".payment-follow").text("twice per month");
      } else if (currentSelection === "Every Two Weeks") {
        $(".payment-follow").text("every two weeks");
      } else if (currentSelection === "Cash price") {
        $(".payment-follow").text("");
      }
      calculatePrice(currentSelection);
      updateBoldPrices(currentSelection);
    } else if ($(this).parent().hasClass("custom-bold-swatch")) {
      var getValue = $(this).text();
      var index = getValue.indexOf("(+"); // Find the position of the '(+' substring

      if (index !== -1) {
        var result = getValue.substring(0, index).trim(); // Extract the substring from the start up to that position
      } else {
        var result = getValue;
      }
      // console.log('here is my actual bold option text were looking for ' + result);
      var boldTitle = $(this).attr("data-bold-swatch");
      boldTitle = boldTitle.substring(0, boldTitle.length - 1);
      // console.log('my bold title is ' + boldTitle);
      var originalText = $(this).attr("data-original-text");
      // console.log('my original text is ' + originalText);
      $(".bold_option_title").each(function () {
        if ($(this).text() === boldTitle) {
          $(this)
            .parent()
            .find("input")
            .each(function () {
              // console.log($(this).val());
              // we uncheck everything and then if it matches our current result, we check it
              $(this).prop("checked", false);
              if (originalText === $(this).val()) {
              //  console.log("we matched " + originalText + $(this).val());
                // $(this).prop('checked',true);
                $(this).trigger("click");
              }
            });
        }
      });
      // anytime these change, we must recalculate price
      calculatePrice($("#payment-plan-selected").text());
    }
  });
  let checkElementInterval = setInterval(function () {
    let element = $(".bold_options_loaded")
      .find(".bold_option_set")
      .find(".bold_option_radio");
    var fullHTML = "";
    if (element.length > 0) {
      // as soon as the bold options are loaded, we must loop through, take this bold information and create a similar look and feel like the theme
      $(".bold_option_radio").each(function (i) {
        var swatchTitle = $(this).find(".bold_option_title").text() + ":";
        var selectedOption = $(this)
          .find(".bold_option_element")
          .find(".bold_option_value")
          .find(".bold_option_value_title")
          .eq(0)
          .text();
        var titleHTML =
          '<div class="swatches__main__container"><p class="swatches__option-name h5"><strong>' +
          swatchTitle +
          '</strong> <span class="swatches__option-value">' +
          selectedOption +
          "</span></p>";
        var parentDivHTML = '<div class="custom-swatches__container">';
        var completeChildHTML = "";
        /// now that the basics are out of the way, we have to loop through the bold option titles to build the radio buttons and swatches
        $(this)
          .find(".bold_option_element")
          .find(".bold_option_value")
          .find(".bold_option_value_title")
          .each(function (y) {
            var childHTML =
              '<div class="custom-swatches__swatch--regular custom-bold-swatch">';
            var data_position = y + 1;
            var originalText = $(this).text();
            var titleText = $(this).text();
            var priceLength = $(this)
              .parent()
              .find(".bold_option_value_price").length;
            var cashPrice = "000";
            if (priceLength > 0) {
              // since we want to do some maths after page load, we store the raw value without decimal or dollar sign

              cashPrice = $(this)
                .parent()
                .find(".bold_option_value_price")
                .text()
                .replace("$", "");
              cashPrice = cashPrice.replace(".", "");
              cashPrice = cashPrice.replace(",", "");
            }
            // based on what the current payment plan is, we need to figure out the right price for this addition after page loads
            var paymentPlan = $("#payment-plan-selected").text();
            var monthlyPrice = (cashPrice * 2) / 18;
            var cashPrice = cashPrice;
            var bimonthlyPrice = monthlyPrice / 2;
            // now we must format these prices
            const formatter = new Intl.NumberFormat("en-US", {
              style: "currency",
              currency: "USD",
            });
            if (cashPrice != "000") {
              if (paymentPlan === "Monthly") {
                titleText =
                  titleText +
                  " (+" +
                  formatter.format(monthlyPrice / 100) +
                  ")";
              } else if (
                paymentPlan === "Bi-Monthly" ||
                paymentPlan === "Every two weeks"
              ) {
                titleText =
                  titleText +
                  " (+" +
                  formatter.format(bimonthlyPrice / 100) +
                  ")";
              } else {
                titleText =
                  titleText +
                  " (+" +
                  $(this).parent().find(".bold_option_value_price").text() +
                  ")";
              }
            }
            if (y === 0) {
              var swatchHTML =
                '<input type="radio" class="custom-swatches__form--input custom-bold-input" value="' +
                titleText +
                '" data-position="' +
                data_position +
                '" checked="checked">';
            } else {
              var swatchHTML =
                '<input type="radio" class="custom-swatches__form--input custom-bold-input" value="' +
                titleText +
                '" data-position="' +
                data_position +
                '">';
            }
            var labelHTML =
              '<label data-bold-swatch="' +
              swatchTitle +
              '" data-cash-price="' +
              cashPrice +
              '" data-original-text="' +
              originalText +
              '" data-monthly-price="' +
              monthlyPrice +
              '" data-twoweek-price="' +
              bimonthlyPrice +
              '" class="custom-swatches__form--label" for="' +
              titleText +
              '">' +
              titleText +
              "</label>";
            completeChildHTML += childHTML + swatchHTML + labelHTML + "</div>";
          });
        fullHTML +=
          titleHTML + parentDivHTML + completeChildHTML + "</div></div>";
      });
      $(".product__section-details__inner--product_buttons").prepend(fullHTML);
      if ($(".custom-swatches__form--label").length > 0) {
        clearInterval(checkElementInterval);
      }
      // when the screen loads, we need to calculate the price
      const paymentPlanDiv = document.getElementById("payment-plan-selected");
      const paymentPlanSelected = paymentPlanDiv.innerHTML;
      const paymentPlanLowerCase = paymentPlanSelected
        ? paymentPlanSelected.toLowerCase()
        : "";
      let paymentPlan = "Cash price";
      switch (paymentPlanLowerCase) {
        case "monthly":
          paymentPlan = "Monthly";
          break;
        case "bi-monthly":
          paymentPlan = "Bi-Monthly";
          break;
        case "every two weeks":
          paymentPlan = "Every Two Weeks";
          break;
        default:
          paymentPlan = "Cash price";
          break;
      }

      // console.log('my payment plan is ' + paymentPlan);
      calculatePrice(paymentPlan);
    }
  }, 50); // Check every 100ms. Adjust as needed.

  // we need a function that calculates price on swatch clicking
  function calculatePrice(paymentPlan) {
    // console.log('my payment plan is ' + paymentPlan);
    // when we click on the custom swatches, we must determine the new pricing and set it
    const getPrice = parseInt(
      $("#product-price-product")
        .find(".price__regular")
        .find(".price-item.price-item--regular")
        .attr("data-money-price")
    );
    const getCompareAtPrice = parseInt(
      $("#product-price-product")
        .find(".price__regular")
        .find(".price-item.price-item--regular")
        .attr("data-compare-at-price")
    );
    // console.log('my price is ' + getPrice);
    let monthlyPrice = (getPrice * 2) / 18;
    let monthlyCompareAtPrice = (getCompareAtPrice * 2) / 18;
    let cashPrice = getPrice;
    let cashCompareAtPrice = getCompareAtPrice;
    let bimonthlyPrice = Number.isNaN(monthlyPrice / 2) ? 0 : monthlyPrice / 2;
    const bimonthlyCompareAtPrice = Number.isNaN(monthlyCompareAtPrice / 2)
      ? 0
      : monthlyCompareAtPrice / 2;
    const formatter = new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
    });
    // any time we do this sort of math, we must take into account the checked bold options by looking at our custom swatches
    // console.log('calculating new price w/ recent payment plan and here is my biMonthly price ' + bimonthlyPrice);
    $(".custom-bold-input").each(function () {
      // we just need to add on all of the different selected bold option pricing to our prices
      if ($(this).prop("checked") === true) {
        monthlyPrice += parseInt(
          $(this).parent().find("label").attr("data-monthly-price")
        );
        cashPrice += parseInt(
          $(this).parent().find("label").attr("data-cash-price")
        );
        let addbiPrice = parseInt(
          $(this).parent().find("label").attr("data-twoweek-price")
        );
        addbiPrice = Math.ceil(addbiPrice);
        bimonthlyPrice += addbiPrice;
      }
    });
    // any time the payment plan changes, we must make sure that the bold prices are showing the correct pricing

    $(".custom-bold-swatch").each(function () {
      const label = $(this).find("label");
      const originalText = label.data("original-text");
      let monthly = label.data("monthly-price");
      let bimonthly = label.data("twoweek-price");
      let cash = label.data("cash-price");
      if (paymentPlan === "Monthly") {
        monthly = formatter.format(monthly / 100);
        label.text(originalText + " (" + monthly + ")");
      } else if (
        paymentPlan === "Bi-Monthly" ||
        paymentPlan === "Every Two Weeks" ||
        paymentPlan === "Bi-Monthly" ||
        paymentPlan === "Every two weeks"
      ) {
        bimonthly = formatter.format(bimonthly / 100);
        label.text(originalText + " (" + bimonthly + ")");
      } else {
        cash = formatter.format(cash / 100);
        label.text(originalText + " (" + cash + ")");
      }
    });

    console.log("paymentPlan", paymentPlan);

    if (paymentPlan === "Monthly") {
      $("#product-price-product")
        .find(".price__regular")
        .find(".price-item.price-item--regular")
        .text(formatter.format(monthlyPrice / 100));
      if (!Number.isNaN(monthlyPrice)) {
        $(
          "#product-price-product .price__sale .price-item--sale[data-regular-price]"
        ).text(formatter.format(monthlyPrice / 100));
        $(
          "#product-price-product-bottom .price__sale .price-item--sale[data-sale-price]"
        ).text(formatter.format(monthlyPrice / 100));
      }
      if (!Number.isNaN(monthlyCompareAtPrice)) {
        $(
          "#product-price-product .price__sale .price-item--regular[data-sale-price]"
        ).text(formatter.format(monthlyCompareAtPrice / 100));
        $(
          "#product-price-product-bottom .price__sale .price-item--regular[data-regular-price]"
        ).text(formatter.format(monthlyCompareAtPrice / 100));
      }
    } else if (
      paymentPlan === "Bi-Monthly" ||
      paymentPlan === "Every Two Weeks" ||
      paymentPlan === "Bi-Monthly" ||
      paymentPlan === "Every two weeks"
    ) {
      $("#product-price-product")
        .find(".price__regular")
        .find(".price-item.price-item--regular")
        .text(formatter.format(bimonthlyPrice / 100));
      if (!Number.isNaN(bimonthlyPrice)) {
        $(
          "#product-price-product .price__sale .price-item--sale[data-regular-price]"
        ).text(formatter.format(bimonthlyPrice / 100));
        $(
          "#product-price-product-bottom .price__sale .price-item--sale[data-sale-price]"
        ).text(formatter.format(bimonthlyPrice / 100));
      }
      if (!Number.isNaN(bimonthlyCompareAtPrice)) {
        $(
          "#product-price-product .price__sale .price-item--regular[data-sale-price]"
        ).text(formatter.format(bimonthlyCompareAtPrice / 100));
        $(
          "#product-price-product-bottom .price__sale .price-item--regular[data-regular-price]"
        ).text(formatter.format(bimonthlyCompareAtPrice / 100));
      }
    } else {
      $("#product-price-product")
        .find(".price__regular")
        .find(".price-item.price-item--regular")
        .text(formatter.format(cashPrice / 100));
      if (!Number.isNaN(cashPrice)) {
        $(
          "#product-price-product .price__sale .price-item--sale[data-regular-price]"
        ).text(formatter.format(cashPrice / 100));
        $(
          "#product-price-product-bottom .price__sale .price-item--sale[data-sale-price]"
        ).text(formatter.format(cashPrice / 100));
      }
      if (!Number.isNaN(cashCompareAtPrice)) {
        $(
          "#product-price-product .price__sale .price-item--regular[data-sale-price]"
        ).text(formatter.format(cashCompareAtPrice / 100));
        $(
          "#product-price-product-bottom .price__sale .price-item--regular[data-regular-price]"
        ).text(formatter.format(cashCompareAtPrice / 100));
      }
    }
  }

  function updateBoldPrices(paymentPlan) {
    $(".custom-bold-swatch label").each(function () {
      var monthlyPrice = parseInt($(this).attr("data-monthly-price"));
      var biMonthlyPrice = parseInt($(this).attr("data-twoweek-price"));
      var cashPrice = parseInt($(this).attr("data-cash-price"));
      const formatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
      });
      var newText = "";
      if (monthlyPrice === 0) {
        // we do nothing because this option doesn't have a price
      } else {
        var getValue = $(this).text();
        var index = getValue.indexOf("(+"); // Find the position of the '(+' substring

        if (index !== -1) {
          var result = getValue.substring(0, index).trim(); // Extract the substring from the start up to that position
        }

        if (paymentPlan === "Monthly") {
          // we change the prices to monthly
          newText = result + " (+" + formatter.format(monthlyPrice / 100) + ")";
        } else if (
          paymentPlan === "Bi-Monthly" ||
          paymentPlan === "Every Two Weeks"
        ) {
          newText =
            result + " (+" + formatter.format(biMonthlyPrice / 100) + ")";
        } else {
          newText = result + " (+" + formatter.format(cashPrice / 100) + ")";
        }
        //
      }
    });
  }

  var windowLoc = window.location.href;
  console.log(windowLoc);
  if (windowLoc.indexOf("/cart") > -1) {
    var interval = setInterval(function () {
      var itemsLength = $(".ajax-cart__cart-item").length;

      // Only run the logic if the length of items is above 0
      if (itemsLength > 0) {
        console.log("running this function");
        console.log("length of items is " + itemsLength);

        $(".ajax-cart__cart-item").each(function () {
          console.log($(this).attr("class"));

          // Determine if this is a unique and main item
          if (
            !$(this).hasClass("item-hide") &&
            $(this).attr("data-unique") != ""
          ) {
            console.log('my data unique is' + $(this).attr('data-unique'));
            var mainUnique = $(this).attr("data-unique");
            console.log("my unique id is " + mainUnique);
            var mainItem = $(this);
            var mainPrice = parseInt(
              $(this).find(".data-cart-item-price").attr("data-price")
            );
            console.log("my main price is " + mainPrice);
            $('ul[data-unique="' + mainUnique + '"]').each(function () {
              // if its an option of our main product, we add the prices to it
              if ($(this).hasClass("item-hide")) {
                console.log(
                  "adding this to price " +
                    parseInt(
                      $(this).find(".data-cart-item-price").attr("data-price")
                    )
                );
                mainPrice += parseInt(
                  $(this).find(".data-cart-item-price").attr("data-price")
                );
              }
            });
            function formatMoney(amount) {
              // Convert the integer amount to a dollar format
              var dollars = (amount / 100).toFixed(2);

              // Use regular expression to add commas for thousands, millions, etc.
              var formatted = dollars
                .toString()
                .replace(/\B(?=(\d{3})+(?!\d))/g, ",");

              return "$" + formatted;
            }
            var formattedPrice = formatMoney(mainPrice);
            // now we replace the main price with this one
            mainItem.find(".data-cart-item-price").text(formattedPrice);
          }
        });

        // If you want the interval to stop after running once, uncomment the line below:
        clearInterval(interval);
      }
    }, 1000); // Checking every 1000ms (1 second)
  }
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || '{{amount}}';
  
    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = precision || 2;
      thousands = thousands || ',';
      decimal = decimal || '.';
  
      if (isNaN(number) || number === null) return '0.00';
  
      number = (number / 100).toFixed(precision);
  
      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';
  
      return dollarsAmount + centsAmount;
    }
  
    var match = formatString.match(placeholderRegex);
    if (match) {
      switch (match[1]) {
        case 'amount':
          value = formatWithDelimiters(cents, 2);
          break;
        case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0);
          break;
        default:
          value = formatWithDelimiters(cents, 2);
      }
    } else {
      value = formatWithDelimiters(cents, 2);
    }
  
    return value;
  }
  function showLoader() {
    // Display an overlay and loader
    $("body").append('<div id="overlay" class="overlay"><div class="loader"></div></div>');
  }
  
  function hideLoader() {
    // Remove the overlay and loader
    $("#overlay").remove();
  }
  
  

  var paymentPlan = $(".payment-plan option:selected").eq(0).text();

  function updateCartSummary(cart) {    
   // console.log('here is my cart ' , cart);
    window.location.replace("/cart/");
    // To keep track of map between old and new keys - Danny Lim
    const keyMap = {};
    
    var cartTotal = 0;
    cart.items.forEach((item) => {
      // Update keyMap - Danny Lim
      const oldKey = item.properties ? item.properties["_oldKey"] : undefined; // old key
      const newKey = item.key; // new key
      if (oldKey && newKey) keyMap[oldKey] = newKey;
      
      var variant = item.variant_id;
      var price = item.price;
      var quantity = item.quantity;
      var priceQ = price * quantity;
      cartTotal += priceQ;
      priceQ = priceQ / 100;
      price = price / 100;
      var formatted = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
      }).format(price);
      var formattedQP = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
      }).format(priceQ);

      $(".ajax-cart__cart-item").each(function () {
        var id = parseInt($(this).attr("data-variant"));
        //   console.log('my id is ' + id);
        if (variant === id) {
          $(this).find(".data-cart-item-price").text(formattedQP);
        }
      });

      // Update UI elements (-, +, x, quantity input) - Danny Lim
      if (oldKey && newKey) {
       // console.log('Replaced old key: ', oldKey, ' with new key', newKey);
        // Replace data-item-key with the new key where old key matches the data-item-key
        $(`[data-item-key="${oldKey}"]`).each(function() {
            $(this).attr('data-item-key', newKey);
        });
      }
    });
    
    cartTotal = cartTotal / 100;
    var formattedTotal = new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
    }).format(cartTotal);
    $(".cart-original-total").text(formattedTotal);
    // even though we have the cart total, we also must update the line items as well
    var payment = $("payment-term-radio:checked").val();
    var uniqueIDs = [];
    if (payment != "Cash price") {
      $(".ajax-cart__cart-item").each(function () {
        // if item is showing, we know it's a primary product and must add the other hidden items to it
        var uniqueID = $(this).data("unique");
        // now we must find the other uniqueIDs and add them to my price
        if (!uniqueIDs.includes(uniqueID) && uniqueID) {
          uniqueIDs.push(uniqueID);
        }
      });
      // Now loop through the uniqueIDs array
      uniqueIDs.forEach(function (id) {
        // Perform your actions with each id
        $(".ajax-cart__cart-item").each(function () {
          // if item is showing, we know it's a primary product and must add the other hidden items to it
          var uniqueID = $(this).data("unique");
          if (!$(this).hasClass("item-hide") && uniqueID === id) {
            // get all the current prices for this id and add them up
            var totalLinePrice = 0;
            $(".ajax-cart__cart-item").each(function () {
              var uniqueID_sub = $(this).data("unique");
              if (uniqueID_sub === uniqueID) {
                var price = $(this).find(".data-cart-item-price").text();
                // Remove the dollar sign and any other non-numeric characters except the decimal point
                price = price.replace(/[^\d.]/g, "");
                // Remove the decimal point
                price = price.replace(".", "");
                price = parseInt(price);
                totalLinePrice += price;
              }
            });
            /*
            var qty = parseInt($(this).find('input').val());
            totalLinePrice = qty * totalLinePrice;
            */
            totalLinePrice = totalLinePrice / 100;
            var formattedLinePrice = new Intl.NumberFormat("en-US", {
              style: "currency",
              currency: "USD",
            }).format(totalLinePrice);
            $(this).find(".data-cart-item-price").text(formattedLinePrice);
          }
        });
      });
    }
    $(".radio-flex span.radio-custom").removeClass("radio-disabled");
                           // at the end of all of this, we check the cart total and see if it is shoudl be enabled or disabled
                           var dataLimit = parseInt($('.ajax-cart__button-submit').attr('data-approval-limit'));
                          cartTotal = parseInt($('.js-cart-subtotal').text().replace('$','').replace(',','').replace('.',''));
    console.log('my original total is ' + cartTotal);
                           var paymentTerm = $('.payment-term-radio:checked').val();
                           if (paymentTerm === 'Every Two Weeks' || paymentTerm === 'Bi-Monthly') {
                            // we have to multiply cartTotal by 2
                            cartTotal = cartTotal * 2;
                           }
                           console.log(paymentTerm);
                           cartTotal = parseInt(cartTotal);
                          console.log('my data limit is ' + dataLimit + ' and my cartTotal is ' + cartTotal);
                           if (dataLimit > cartTotal || paymentTerm === 'Cash price') {
                            // re-enable button
                            console.log('trying to remove disabled');
                                 $(".ajax-cart__button-submit").each(function () {
          $(this).prop("disabled", false);
          $(this).removeAttr('style');
          });
                           }
  }

  ////////////////////////////////
  ////// ADDED BY DANNY LIM //////
  ////////////////////////////////
  /**
   Changes a cart item's quantity
   @param {number} uniqueID
   @param {string} oldKey
   @param {number} quantityChange
   @param {boolean} quantityReplace
   */
  async function cartItemQuantityChanged(uniqueID, oldKey, quantityChange, quantityReplace) {
    return new Promise(function (resolve, reject) {
      uniqueID = uniqueID.toString();
      $(".radio-flex span.radio-custom").addClass("radio-disabled");
      // console.log('Radio buttons disabled.');

      // Create map of old keys to new keys - Danny Lim
      const keyMap = {};

      $.ajax({
        type: "GET",
        url: "/cart.js",
        dataType: "json",
        success: function (cart) {
          console.log("Received cart data:", cart);
          var items = [];
          const cartItems = cart.items;
          let newQty = null;
          let line = null;
          let updateProperties = null;

          $(cartItems).each(function (i) {
            var thisItem = $(this)[0];
            console.log('this is my item ' , thisItem);
            if (thisItem.properties && thisItem.properties["_uniqueID"] == uniqueID) {
              const thisItemProperties = { ...thisItem.properties };
              thisItemProperties["_oldKey"] = oldKey; // Set the new '_oldKey'

              // Update Line
              line = i + 1;

              // Update Quantity
              const previousQty = thisItem.quantity;
              newQty = quantityReplace ? quantityChange : quantityChange === 0 ? 0 : previousQty + quantityChange;

              // Update Properties
              updateProperties = { ...thisItemProperties };
                      // Create an object with the variant and quantity
        var item = {
          line:line,
          quantity: newQty,
          properties: updateProperties
        };
        // Push the object into the items array
        items.push(item);

            }
          });
          console.log('here is what i need to update cart with ' , items);
          updateCartItemsSequentially(items);
           // Function to perform update
           async function updateCartItemsSequentially(items) {
            for (let item of items) {
                await updateCartItem(item);
            }
            // After all items are updated, retrieve the cart summary
            getCartSummaryAndUpdate();
        }
        function updateCartItem(item) {
          return new Promise((resolve, reject) => {
              $.ajax({
                  url: '/cart/change.js',
                  method: 'POST',
                  dataType: 'json',
                  data: item,
                  success: function(response) {
                      console.log('Cart updated successfully for line ', item.line, response);
                      resolve(response);  // Resolve the promise with the response
                  },
                  error: function(xhr, status, error) {
                      console.error('Failed to update cart for line ', item.line, error);
                      reject(error);  // Reject the promise with the error
                  }
              });
          });
      }
      
        function getCartSummaryAndUpdate() {
            $.ajax({
                type: "GET",
                url: "/cart.js",
                dataType: "json",
                success: function (cart) {
                    updateCartSummary(cart);
                    $('.ajax-cart__qty-control--up,.ajax-cart__qty-control--down,.ajax-cart__qty-input').prop('disabled',false);
                    console.log('Cart summary updated successfully.');
                },
                error: function(xhr, status, error) {
                    console.error('Failed to update cart summary', error);
                }
            });
        }
        }
      });
    });
  }

  /**
   Gets the nearest UL parent and the data-unique attribute
   @param {HTMLElement} $eventTarget
   @param {number} quantityChange
   @param {boolean} quantityReplace
  */
  function getNearestUlDataUnique($eventTarget, quantityChange, quantityReplace) {
    // Ensure the event target is wrapped in jQuery
    const $target = $($eventTarget);

    // Retrieve and return the 'data-item-key' attribute value
    let $oldKey = $target.data('item-key'); // Using .data() to get data attributes

    // If the 'data-item-key' isn't found on the target, look for the closest sibling input
    if ($oldKey === undefined) {
        var $siblingInput = $target.siblings('input').first(); // Gets the first input sibling if present
        if ($siblingInput.length) {
            $oldKey = $siblingInput.data('item-key'); // Attempt to retrieve 'data-item-key' from the sibling
        }
    }

    // Use jQuery's closest method to find the nearest ul parent
    const $ul = $target.closest('ul');

    // Check if a 'UL' has been found
    if ($ul.length) {
        // Retrieve and return the 'data-unique' attribute value
        const $uniqueID = $ul.data('unique'); // Using .data() to get data attributes

        if ($uniqueID && $oldKey && typeof quantityChange === "number") {
          // Call function
          cartItemQuantityChanged($uniqueID, $oldKey, quantityChange, quantityReplace || false); 
        }
    } else {
        // Log and return null if no 'UL' element found
        console.error("No nearest 'UL' parent found.");
    }
  }

  $(document).on("click", "[custom-data-ajax-qty-decrease]", function (e) {
    var existingInput = parseInt($(this).parent().find('input').val());
    var newQty = existingInput - 1;
    $('.ajax-cart__qty-control--up,.ajax-cart__qty-control--down,.ajax-cart__qty-input').prop('disabled',true);
    $(this).parent().find('input').val(newQty);
    getNearestUlDataUnique(e.target, -1, false);
  });

  $(document).on("click", "[custom-data-ajax-qty-increase]", function (e) {
    var existingInput = parseInt($(this).parent().find('input').val());
    var newQty = existingInput + 1;
    $('.ajax-cart__qty-control--up,.ajax-cart__qty-control--down,.ajax-cart__qty-input').prop('disabled',true);
    $(this).parent().find('input').val(newQty);
    getNearestUlDataUnique(e.target, 1, false);
  });
/*
  $(document).on("click", ".custom-ajax-cart__item-remove", function (e) {
    $('.ajax-cart__qty-control--up,.ajax-cart__qty-control--down,.ajax-cart__qty-input').prop('disabled',true);
    getNearestUlDataUnique(e.target, 0, false);
  });
*/
  $(document).on("change", ".custom-ajax-cart__qty-input", function (e) {
    $('.ajax-cart__qty-control--up,.ajax-cart__qty-control--down,.ajax-cart__qty-input').prop('disabled',true);
    const newQuantity = (typeof e.target.value === "number" ? e.target.value : parseInt(e.target.value, 10));
    getNearestUlDataUnique(e.target, newQuantity, true);
  });

  ////////////////////////////////////
  ////// END ADDED BY DANNY LIM //////
  ////////////////////////////////////

      // Attach event handler for remove button
      $('body').on('click', '.ajax-cart__item-remove--icon', function() {
        var thisRemove = $(this).parent();
        $.getJSON('/cart.js', function(cart) {
          var uniqueID = thisRemove.data('unique-id');
          console.log('Removing items with unique ID:', uniqueID);
        // Create an object to hold updates for items with the matching uniqueID
        var updates = {};
        cart.items.forEach(function(item) {
          console.log(item);
          for (var key in item.properties) {
            console.log(key + ' and my properties are ' + item.properties[key]);
            if (item.properties.hasOwnProperty(key) && key === '_uniqueID' && String(item.properties[key]) === String(uniqueID)) {
             // console.log('we matched on unique ID');
              updates[item.key] = 0; // Set quantity to 0
              break;
            }
          }
        });
              // Update the cart
      if (Object.keys(updates).length > 0) {
        console.log('yes');
        $.ajax({
          type: 'POST',
          url: '/cart/update.js',
          data: JSON.stringify({ updates: updates }),
          contentType: 'application/json',
          dataType: 'json',
          success: function() {
            console.log('All items with unique ID ' + uniqueID + ' have been removed.');
            location.reload(); // Reload the page to reflect the changes
          },
          error: function() {
            console.error('Failed to update some items.');
          }
        });
      }
    });
      });
      $('body').on('click', '.zajax-cart__item-qty button', function (e) {
        showLoader();
        $(".ajax-cart__button-submit").each(function () {
          $(this).prop("disabled", true);
          $(this).css("background-color", "#727272");
          $(this).css("cursor", "default");
          });
        var thisClass = $(this).attr('class');
        var $input = $(this).parent().find('input');
        var thisQty = parseInt($input.val());
        var newQty;
        var key = $(this).attr('custom-data-ajax-qty-key') || $(this).attr('custom-data-ajax-key');
      
        if (thisClass.indexOf('--down') !== -1) {
          newQty = thisQty - 1;
        } else {
          newQty = thisQty + 1;
        }
      
        if (newQty < 0) {
          newQty = 0; // Ensure the quantity does not go below 0
        }
      
        // Update the cart with the new quantity
        var updates = {};
        updates[key] = newQty;
      
        $.ajax({
          type: 'POST',
          url: '/cart/update.js',
          data: JSON.stringify({ updates: updates }),
          contentType: 'application/json',
          dataType: 'json',
          success: function (cart) {
            console.log('Cart updated successfully.', cart);
            $input.val(newQty);
            updateCartSummary(cart);
          },
          error: function (jqXHR, textStatus, errorThrown) {
            console.log('AJAX call failed.');
            console.log('Status: ' + textStatus);
            console.log('Error: ' + errorThrown);
            console.log('Response: ' + jqXHR.responseText);
          }
        });
        hideLoader();
      });
      function newOptionSelected(selectedOption) {
        showLoader();
        console.log("Setting new payment term option: ", selectedOption);
        $(".radio-flex span.radio-custom").addClass("radio-disabled");
      
        // Capture the original order of items from the HTML
        var originalOrder = [];
        $('#custom-cart-items tr').each(function () {
          originalOrder.push($(this).find('.item-title-cart h3').text().trim());
        });
      
        $.ajax({
          type: "GET",
          url: "/cart.js",
          dataType: "json",
          success: function (cart) {
            console.log("Received cart data:", cart);
            var cartItems = cart.items; // Original cart with old keys
            let items = [];
      
            $(cartItems).each(function (i) {
              let properties_empty_array = [];
              var thisItem = $(this)[0];
      
              var properties = {};
              $(thisItem.properties).each(function (key, value) {
                if (key !== "Payment plan") {
                  // Preserve all other properties except 'Payment plan'
                  properties[key] = value;
                }
              });
              properties[0]["Payment plan"] = selectedOption; // Set the new 'Payment plan'
              properties[0]["_oldKey"] = thisItem.key; // Set old key
      
              const itemObj = {
                id: thisItem.variant_id,
                quantity: thisItem.quantity,
                properties: properties[0],
                title: thisItem.title // Save the product title
              };
              items.push(itemObj);
            });
      
            $.ajax({
              type: "POST",
              url: "/cart/clear.js",
              dataType: "json",
              success: function () {
                if (items && items.length) {
                  $.ajax({
                    type: "POST",
                    url: "/cart/add.js",
                    data: { items: items },
                    dataType: "json",
                    success: function (data) {
                      console.log("Cart updated with new payment plan.", data);
                      updateCartSummary(data);
                      // Change payment term in left part of cart
                      $(".property-p").each(function () {
                        if ($(this).text().trim().indexOf("Payment plan") > -1) {
                          $(this).text("Payment plan: " + selectedOption);
                        }
                      });
                      // Change payment term label in cart items
                      $(".data-cart-item-price-payment-term").each(function () {
                        if (selectedOption == "Cash price") {
                          $(this).text("");
                        } else if ($(this)) {
                          $(this).text(selectedOption);
                        }
                      });
                      // Disable / Enable Submit Button in Cart
                      $(".ajax-cart__button-submit").each(function () {
                        if (selectedOption === "Cash price") {
                          $(this).prop("disabled", false);
                          $(this).css("background-color", "#ff5733");
                          $(this).css("cursor", "pointer");
                        } else {
                          $(this).prop("disabled", true);
                          $(this).css("background-color", "#727272");
                          $(this).css("cursor", "default");
                        }
                      });
                      $(".ajax-cart__button-submit").each(function () {
                        if (selectedOption === "Cash price") {
                          $(this).prop("disabled", false);
                          $(this).css("background-color", "#ff5733");
                          $(this).css("cursor", "pointer");
                        } else {
                          // we need to figure out if they are still eligible before disabling
                 var dataLimit = parseInt($('.ajax-cart__button-submit').attr('data-approval-limit'));
                          cartTotal = parseInt($('.js-cart-subtotal').text().replace('$','').replace(',','').replace('.',''));
    console.log('my original total is ' + cartTotal);
                           var paymentTerm = $('.payment-term-radio:checked').val();
                           if (paymentTerm === 'Every Two Weeks' || paymentTerm === 'Bi-Monthly') {
                            // we have to multiply cartTotal by 2
                            cartTotal = cartTotal * 2;
                           }
                           console.log(paymentTerm);
                           cartTotal = parseInt(cartTotal);
                          console.log('my data limit is ' + dataLimit + ' and my cartTotal is ' + cartTotal);
                           if (dataLimit > cartTotal || paymentTerm === 'Cash price') {
                            // re-enable button
                            console.log('trying to remove disabled');
                                 $(".ajax-cart__button-submit").each(function () {
          $(this).prop("disabled", false);
          $(this).removeAttr('style');
          });
                        }
                        }
                      });
                      // Show / Remove warnings
                      $(".payment-restriction-warning").each(function () {
                        if (selectedOption == "Cash price" && $(this).text().indexOf('register for an account') === 0) {
                          $(this).css("display", "none");
                          $(this).css("visibility", "hidden");
                        } else {
                          $(this).css("display", "block");
                          $(this).css("visibility", "visible");
                        }
                      });
                      // Show / Remove warnings in tooltip
                      $(".tooltip-text").each(function () {
                        if (selectedOption == "Cash price" && $(this).text().indexOf('register for an account') === 0) {
                          $(this).css("display", "none");
                        } else {
                          $(this).css("display", "inline-block");
                        }
                      });
      
                      // Sort items based on the original order by title before appending
                      var $cartItems = $('#custom-cart-items');
                      $cartItems.empty(); // Clear existing items
      
                      data.items.sort(function (a, b) {
                        var aIndex = originalOrder.indexOf(a.title.trim());
                        var bIndex = originalOrder.indexOf(b.title.trim());
                        if (aIndex === -1) return 1; // If a is not in originalOrder, place it at the end
                        if (bIndex === -1) return -1; // If b is not in originalOrder, place it at the end
                        return aIndex - bIndex;
                      });
      
                      data.items.forEach(function (item) {
                     //   console.log(item);
                        var imgSrc = item.featured_image ? item.featured_image.url : '';
                        // Get properties and find uniqueID
                        var propertiesHtml = '';
                        var uniqueID = '';
                        item.options_with_values.forEach(function(option) {
                          if (option.value !== 'Default Title') {
                            propertiesHtml += `<p class="property-p"><b>${option.name}</b>: <span class="actual-option">${option.value}</span></p><br>`;
                          }
                        });
                        var quantity_allowed = 'visibility:hidden;';
                        // Add other properties to properties HTML
                        for (var key in item.properties) {
                          if (!item.properties) return;
                          if (item.properties.hasOwnProperty(key)) {
                            var value = item.properties[key];
                            let hideStyle = (key === 'Payment plan' || key.charAt(0) === '_') ? 'display:none;' : '';
                            propertiesHtml += `<p class="property-p" style="${hideStyle}"><b>${key}</b>: <span class="actual-option">${value}</span></p>`;
                            if (hideStyle === '') {
                              propertiesHtml += '<br>';
                            }
                            if (key === '_uniqueID') {
                              uniqueID = value;
                            }
                            if (key === '_Tags' && value.indexOf('quantity-allowed') > -1) {
                              quantity_allowed = '';
                            }
                          }
                        }
                        // Calculate item price including custom items
                        var itemPrice = 0;
                        var selectedOption = '';
                        data.items.forEach(function(customItem) {
                          for (var p in customItem.properties) {
                            if (customItem.properties.hasOwnProperty(p) && p === '_uniqueID' && customItem.properties[p] === uniqueID) {
                          //    console.log('matched adding this price to itemPrice ' + customItem.price);
                              itemPrice += customItem.price;
                            }
                            if (p === 'Payment plan') {
                              selectedOption = customItem.properties[p];
                            }
                          }
                        });
                  
                        // Format the item price
                        var formattedPrice = formatMoney(itemPrice, '{{amount}}');
                        const isHiddenProduct = item.product_type === 'OPTIONS_HIDDEN_PRODUCT';
                        const itemClass = isHiddenProduct ? 'item-hide' : '';
                  
                        // Create the HTML for this item
                        const itemHtml = `
                          <tr class="${itemClass}" data-item-key="${item.key}" data-variant="${item.variant_id}" data-product-type="${item.product_type}">
                            <td class="reg-cart-item-image">
                              ${imgSrc ? `<img src="${imgSrc}" style="height:100px;width:100px;">` : ''}
                            </td>
                            <td>
                              <span class="item-title-cart">
                                <h3 class="zactual-title-cart"><a href="${item.url}">${item.product_title}</a></h3>
                                <div class="properties-holder">
                                  ${propertiesHtml}
                                </div>
                              </span>
                            </td>
                            <td>
                               <div class="zajax-cart__item-qty v-center zjs-item-quantity ${quantity_allowed === 'visibility:hidden;' ? 'hidden-on-mobile' : ''}" style="${quantity_allowed}">
                                <div class="zajax-cart__item-quantity a-left">
                                  <button custom-data-ajax-qty-key="${item.key}" class="zajax-cart__qty-control--down mb0 v-center" type="button">
                                    -
                                  </button>
                                  <input disabled class="zajax-cart__qty-input v-center a-center" data-item-line="1" min="1" type="text" name="updates[]" value="${item.quantity}">
                                  <button custom-data-ajax-key="${item.key}" class="zajax-cart__qty-control--up mb0 v-center" type="button">
                                    +
                                  </button>
                                </div>
                                <input class="ajax-cart__item-update--no-js button-as-link" type="submit" name="update" style="display:none;" value="Update Cart">
                              </div>
                            </td>
                            <td class="cart-item-price">
                              $${formattedPrice} <span class="data-cart-item-price-payment-term">${selectedOption}</span>
                              <p data-unique-id="${uniqueID}" class="remove-cart">X</p>
                            </td>
                          </tr>
                        `;
                  
                        // Append the item HTML to the cart
                        $cartItems.append(itemHtml);
                      });
                      hideLoader();
                      // at the end of all of this, we check the cart total and see if it is shoudl be enabled or disabled
                     var dataLimit = parseInt($('.ajax-cart__button-submit').attr('data-approval-limit'));
                     var cartTotal = parseInt($('.js-cart-subtotal').text().replace('$','').replace(',','').replace('.',''));
                  //    console.log('my original total is ' + cartTotal)
                     var paymentTerm = $('.payment-term-radio:checked').val();
                     if (paymentTerm === 'Every Two Weeks' || paymentTerm === 'Bi-Monthly') {
                      // we have to multiply cartTotal by 2
                      cartTotal = cartTotal * 2;
                     }
                     console.log(paymentTerm);
                     cartTotal = parseInt(cartTotal);
                   //   console.log('my cart total is ' + cartTotal + ' and my dataLimit is ' + dataLimit);
                     if (dataLimit > cartTotal || (paymentTerm === 'Cash price' && $(this).text().indexOf('register for an account') === 0)) {
                      // re-enable button
        $(".ajax-cart__button-submit").each(function () {
          $(this).prop("disabled", false);
          $(this).removeAttr('style');
          });
                     }
                    },
                    error: function (jqXHR, textStatus, errorThrown) {
                      console.log("AJAX call failed.");
                      console.log("Status: " + textStatus);
                      console.log("Error: " + errorThrown);
                      console.log("Response: " + jqXHR.responseText);
                      hideLoader(); // Hide loader on error
                    },
                  });
                } else {
                  console.log("Cart cleared successfully");
                  hideLoader(); // Hide loader if no items to add
                }
              },
              error: function () {
                const failText = "Failed to clear cart";
                console.log(failText);
                hideLoader(); // Hide loader on error
              },
            });
          },
          error: function () {
            const failureText = "Failed to fetch updated cart information";
            console.log(failureText);
            hideLoader(); // Hide loader on error
          },
        });
      }
      
      
    
      $(document).on(
        "click",
        ".radio-flex span.radio-custom, .radio-flex label",
        function (event) {
          showLoader();
          if (event.target.tagName.toUpperCase() === "LABEL") {
            var thisTarget = $(this).parent().find(".radio-custom");
            // You can add your specific logic for when a label is clicked here
          } else {
            var thisTarget = $(this);
            // Logic for other elements clicked
          }
          if (thisTarget.hasClass("radio-disabled")) {
            // we do absolutely nothing because changes still loading from previous click
          } else {
            $(".radio-flex span.radio-custom").removeClass("active");
            thisTarget.addClass("active");
            $(".radio-flex input:radio").prop("checked", false);
            thisTarget.prev("input:radio").prop("checked", true);
            newOptionSelected(thisTarget.prev("input:radio").attr("value"));
          }
        hideLoader();
        }
      );
    $('body').on('click','#clear-cart-bulk',function(e) {
    e.preventDefault();
$.ajax({
            type: "POST",
            url: "/cart/clear.js",
            dataType: "json",
            success: function () {
              window.location.href = '/cart';
            }
            });
    
  });
// custom.js

(function () {
  var COOKIE = "return_to";
  var DEST = "/a/manage-account";

  function getCookie(name) {
    var m = document.cookie.match(new RegExp("(^|; )" + name + "=([^;]+)"));
    return m ? decodeURIComponent(m[2]) : null;
  }

  function clearCookie(name) {
    // Clear the host-only cookie (what your screenshot shows)
    document.cookie = name + "=; Path=/; Max-Age=0; SameSite=Lax";
    // Also try to clear domain-scoped in case it was set differently
    var domain = location.hostname.replace(/^www\./, "");
    document.cookie = name + "=; Path=/; Max-Age=0; SameSite=Lax; Domain=" + domain;
    document.cookie = name + "=; Path=/; Max-Age=0; SameSite=Lax; Domain=." + domain;
    try { localStorage.removeItem(name); } catch (_) {}
  }

  function inDest(path) {
    return path === DEST || path === DEST + "/" ||
           path.indexOf(DEST + "?") === 0 || path.indexOf(DEST + "#") === 0;
  }

  // ---- Boot logic ----

  // 1. Seed cookie from ?return_to=... (only if param present)
  (function seedFromQuery() {
    var q = new URLSearchParams(location.search);
    var rt = q.get("return_to");
    if (rt) {
      // Normalize to just the path
      try {
        var u = new URL(rt, location.origin);
        var p = u.pathname + (u.search || "") + (u.hash || "");
        document.cookie = COOKIE + "=" + encodeURIComponent(p) + "; Path=/; SameSite=Lax";
      } catch (e) {
        if (rt.charAt(0) === "/") {
          document.cookie = COOKIE + "=" + encodeURIComponent(rt) + "; Path=/; SameSite=Lax";
        }
      }
    }
  })();

  // 2. If already on the destination, nuke cookie (prevents loops)
  if (inDest(location.pathname)) {
    clearCookie(COOKIE);
    return;
  }

  // 3. If on /account, redirect ONCE if cookie exists
  if (location.pathname === "/account") {
    var rt = getCookie(COOKIE);
    if (rt && inDest(rt)) {
      clearCookie(COOKIE);
      window.location.replace(rt); // replaces history entry
    }
  }

  // 4. Expose a safe redirect function for other scripts
  window.redirectToApplication = function () {
    if (inDest(location.pathname)) return; // don't redirect off destination
    var rt = getCookie(COOKIE);
    if (rt && inDest(rt)) {
      clearCookie(COOKIE);
      window.location.replace(rt);
    } else {
      window.location.replace("/apps/apply");
    }
  };
})();
});
